import React, { useState, useEffect } from 'react';
import _ from 'lodash';

import { W } from '../i18n';

function LoadingText({ text }: { text?: string }) {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const dotCountInterval = setInterval(() => {
      setDotCount(prev => (prev + 1) % 4);
    }, 400);

    return () => clearInterval(dotCountInterval);
  }, []);

  return (
    <span>
      <span>{text || W('shared.loadingText.loading')}</span>
      <span>{_.fill(_.range(0, dotCount), '.').join('')}</span>
      <span style={{ color: 'transparent' }}>
        {_.fill(_.range(0, 3 - dotCount), '.').join('')}
      </span>
    </span>
  );
}

export default LoadingText;
